module.exports = __webpack_public_path__ + "fonts/TitlingGothicFBCond-Bold.213f9bc2.ttf";